import * as React from "react";
import { Button, ButtonGroup, Field } from "@/components/ui";
import { PromptType } from "@/interfaces";
import { cn } from "@/lib/utils";

interface Props {
  values: {
    type: PromptType;
  };
  disabled: boolean;
  handleSetFieldValue?: (field: string, value: any) => void;
}

export function PromptTypeSelector({ values: { type }, handleSetFieldValue, disabled }: Props) {
  return (
    <Field>
      <Field.Label>Prompt Type</Field.Label>
      <ButtonGroup>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className={cn(
            type === PromptType.FEED
              ? "bg-primary text-primary-foreground hover:bg-primary/80 hover:text-primary-foreground"
              : ""
          )}
          disabled={disabled}
          onClick={() => handleSetFieldValue!("type", PromptType.FEED)}
          aria-pressed={type === PromptType.FEED}
        >
          Feed Prompt
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className={cn(
            type === PromptType.REELS
              ? "bg-primary text-primary-foreground hover:bg-primary/80 hover:text-primary-foreground"
              : ""
          )}
          disabled={disabled}
          onClick={() => handleSetFieldValue!("type", PromptType.REELS)}
          aria-pressed={type === PromptType.REELS}
        >
          Reels Prompt
        </Button>
      </ButtonGroup>
    </Field>
  );
}
